
import { getHiddenDataString, getIsChina } from "../../domain/hidden-data-provider";
import { getGdprCookie, getGdprError } from "../gdpr/domain/gdpr-provider";

export default class YotpoPreview{

    static Init(yotpoApiKey,skuNum, productImg) {
        const gdpr = getGdprCookie();
        const GDPRisFunctional = gdpr.IsFunctional;


        if(getIsChina()){
            let elem = document.getElementById('tab-reviews');
            if(elem !== null) {
                elem.parentNode.removeChild(elem);
                return false;
            }
        }

        //if(window.gdpr && window.gdpr.isFunctional) {
        if(GDPRisFunctional) {
            //console.log(`1. y otpoApiKey: ${yotpoApiKey} | skuNum: ${skuNum} | productImg: ${productImg} }`);

            let productTitle ='';
            const domain = window.location.host;
            const productUrl = window.location.href;
            //complete sending data if need
            if(!yotpoApiKey && document.getElementById('yotpo-api-key'))
                yotpoApiKey = document.getElementById('yotpo-api-key').textContent;

            if(!skuNum && document.getElementById('skunumber'))
                skuNum = document.getElementById('skunumber').textContent;

            if(!productImg) {
                let productImgEl = document.getElementById('PreviewImage');

                if(productImgEl){
                    productTitle = productImgEl.getAttribute('data-yotpo-title');
                }
                if(productImgEl && productImgEl.children && productImgEl.children[0]){
                    productImg = productImgEl.children[0].src;
                    if(productImg && productImg !== '')
                        productImg = productImg.split('?')[0];
                    // console.log(productImg);
                }

            }

            //------------------
            const yotpoReviews = document.getElementById('yotpo-reviews');
            if(yotpoReviews) {

                /*
                <div
                    class="yotpo-widget-instance"
                    data-yotpo-instance-id="669497"
                    data-yotpo-product-id="Product ID"
                    data-yotpo-name="Product Title"
                    data-yotpo-url="The URL of your product page"
                    data-yotpo-image-url="The product image URL"
                    data-yotpo-price="Product Price"
                    data-yotpo-currency="Product Currency"
                    data-yotpo-description="Product Description"></div>
                 */
                if(!yotpoReviews.classList.contains('yotpo-widget-instance')) {
                    yotpoReviews.classList.add('yotpo-widget-instance');
                }

                yotpoReviews.setAttribute('data-yotpo-instance-id', getHiddenDataString('yotpo-instance-id'));
                yotpoReviews.setAttribute('data-yotpo-product-id', skuNum);
                yotpoReviews.setAttribute('data-yotpo-name', productTitle);
                yotpoReviews.setAttribute('data-yotpo-url', productUrl);
                yotpoReviews.setAttribute('data-yotpo-image-url', productImg);
                yotpoReviews.setAttribute('data-appkey', yotpoApiKey);
                yotpoReviews.setAttribute('data-domain', domain);
                yotpoReviews.classList.remove('hidden');

                /*
                yotpoReviews.setAttribute('data-appkey', yotpoApiKey);
                yotpoReviews.setAttribute('data-domain', domain);
                yotpoReviews.setAttribute('data-product-id', skuNum);
                yotpoReviews.setAttribute('data-name', productTitle); //  || document.querySelector('h1')?.textContent?.trim()
                yotpoReviews.setAttribute('data-url', productUrl);
                yotpoReviews.setAttribute('data-image-url', productImg);*/

                // Call Youtpo script
                // <script src="https://cdn-widgetsrepository.yotpo.com/v1/loader/{key from azure}" async></script>
                window.yotpo_app_key = yotpoApiKey;
                (function e1() {
                    var e = document.createElement('script');
                    e.type = 'text/javascript';
                    e.async = true;
                    e.src = `https://cdn-widgetsrepository.yotpo.com/v1/loader/${yotpoApiKey}`; // "//staticw2.yotpo.com/" + yotpoApiKey + "/widget.js";
                    var t = document.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(e, t)
                })();
            }
        }
        else {
            console.log('NOT window.gdpr && window.gdpr.isFunctional');
            const yotpoReviews = document.getElementById('yotpo-reviews');
            if(yotpoReviews) {
                yotpoReviews.innerHTML = getGdprError();
                yotpoReviews.classList.remove('hidden');
            }
        }
    }
}

